import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import {
  PropertyDto,
  PropertyMediaDto,
  PropertyPhotoDto,
  PropertyVerificationStatus,
} from '@workspace/data-types';
import { EtxeEnumDisplayPipe } from '../../../pipes/etxe-enum-display.pipe';
import { EtxePropertyPhotoCarouselComponent } from '../carousel/photos-carousel';

@Component({
  selector: 'etxe-property-photos-display',
  imports: [
    CommonModule,
    RouterLink,
    MatIconModule,
    MatChipsModule,
    MatButtonModule,
    MatTooltipModule,
    EtxeEnumDisplayPipe,
    MatDialogModule,
  ],
  templateUrl: './photos-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyPhotosDisplayComponent {
  private readonly dialog = inject(MatDialog);

  media = input<PropertyMediaDto | null | undefined>(undefined);
  property = input<PropertyDto>();
  variant = input<'grid' | 'mosaic'>('grid');
  isOwner = input<boolean>(false);

  photos = computed<PropertyPhotoDto[]>(() => this.property()?.media?.photos || this.media()?.photos || []);
  mainPhoto = computed<PropertyPhotoDto | null>(() => this.photos()[0] || null);
  secondaryPhotos = computed<PropertyPhotoDto[]>(() => this.photos().slice(1, 5));
  propertyTitle = computed<string>(() => this.property()?.presentation?.title || 'Photo principale du bien');
  isVerified = computed<boolean>(
    () => this.property()?.verification?.owner === PropertyVerificationStatus.VERIFIED,
  );
  propertyId = computed<string | undefined>(() => this.property()?._id?.toString());

  openCarousel(index: number) {
    const photosList = this.photos();
    if (!photosList.length) return;

    this.dialog.open(EtxePropertyPhotoCarouselComponent, {
      data: {
        photos: photosList,
        initialIndex: index,
        characteristics: this.property()?.characteristics,
      },
      panelClass: 'full-screen-dialog',
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      width: '100vw',
    });
  }
}
